import React, { useState, useEffect, useRef } from "react";
import { SelectContainer, StyledSelectContainer, StyledSelect, Prefix, Suffix, DropdownItem, DropdownMenu } from "./styles";

const Select = ({ options, onChange, prefix, suffix, searchable, defaultValue }) => {
  const [isOpen, setIsOpen] = useState(false);
  const initialSelected = !defaultValue || searchable || !options[0]?.name?.trim() ? { name: "Search" } : defaultValue || options[0];

  const [selectedOption, setSelectedOption] = useState(initialSelected);
  const [searchQuery, setSearchQuery] = useState("");
  const containerRef = useRef(null);

  const handleSelectClick = () => {
    setIsOpen(!isOpen);
    setSearchQuery(!isOpen ? "" : searchable && selectedOption?.name !== "Search" ? selectedOption.name : "");
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    setSearchQuery("");
    onChange({ target: { value: option } });
  };

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Update selected option if defaultValue changes
    if (defaultValue) {
      setSelectedOption(defaultValue);
    }
  }, [defaultValue]);

  const filteredOptions = options.filter((option) => option.name.toLowerCase().includes(searchQuery.toLowerCase()));

  return (
    <SelectContainer ref={containerRef}>
      <StyledSelectContainer onClick={handleSelectClick}>
        {prefix && <Prefix>{prefix}</Prefix>}
        <StyledSelect>
          {isOpen && searchable ? (
            <input type="text" placeholder="Search" value={searchQuery} onChange={handleSearchChange} autoFocus style={{ width: "100%", padding: "2px", border: "none", outline: "none" }} />
          ) : (
            selectedOption?.name
          )}
        </StyledSelect>
        {suffix ? (
          <Suffix>{suffix}</Suffix>
        ) : (
          <Suffix>
            <svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M16.293 0.292969L17.7072 1.70718L9.00008 10.4143L0.292969 1.70718L1.70718 0.292969L9.00008 7.58586L16.293 0.292969Z" />
            </svg>
          </Suffix>
        )}
      </StyledSelectContainer>
      {isOpen && (
        <DropdownMenu>
          {filteredOptions.map((option) => (
            <DropdownItem key={option.id} onClick={() => handleOptionClick(option)}>
              {option.name}
            </DropdownItem>
          ))}
        </DropdownMenu>
      )}
    </SelectContainer>
  );
};

export { Select };
